import CollectionDetailsCard from './CollectionDetailsCard';



export default CollectionDetailsCard;
